class EditOrder {
	constructor(el) {
		this.init(el);
	}

	init(el) {
		this.container = el;

		const removedButtons = this.container.querySelector('[data-order-removed]');
		const savedButton = this.container.querySelector('[data-order-saved]');

		if (removedButtons) {
			removedButtons.addEventListener('click', () => {
				savedButton.classList.add('_active');
			});
		}
	}
}

document.querySelectorAll('[data-edit-order]').forEach((el) => new EditOrder(el));
export default EditOrder;
